@if (assistantItem()?.id === 'new_assistant') {
  <div class="assistant-item" (click)="openNewAssistantPageSettings()">
    <u-icon class="assistant-icon" [model]="{ type: 'font', value: 'icon-plus' }" [styles]="{ fontSize: '14px' }"></u-icon>
    <span class="title"> New Assistant </span>
  </div>
} @else {
  <div class="assistant-item" (click)="!isHeader() && navigateToNewChat()">
    <assistant-icon
      class="assistant-icon"
      [model]="assistantItem()"
      [iconStyles]="{ fontSize: '14px', width: '16px', height: '16px', display: 'flex' }"
      [spriteEmojiSize]="16"
    ></assistant-icon>
    <div class="wrapper-action">
      <span
        #AssistantItemTitle
        (mouseenter)="updateTooltip(AssistantItemTitle)"
        class="title"
        [innerHTML]="assistantItem()?.name || 'Inactive Assistant'"
        [tooltipDisabled]="tooltipDisabled()"
        [pTooltip]="assistantItem()?.name"
        tooltipPosition="right"
        tooltipStyleClass="u-tooltip"
      >
      </span>
      <div class="actions">
        @if (!isSmallScreen() && isHeader()) {
          @if (isPinned()) {
            <u-button
              type="secondary"
              class="sidebar-button"
              fontIcon="Close-panel-left"
              (onClick)="setSidebarPinnedState(false)"
              [pTooltip]="'Close chat sidebar'"
              tooltipPosition="bottom"
              tooltipStyleClass="u-tooltip bottom-left"
              [versionNumber]="2"
              [sizeElement]="'small'"
            >
            </u-button>
          } @else {
            <u-button
              *ngIf="!isPinned() && !isSmallScreen()"
              type="secondary"
              class="sidebar-button"
              fontIcon="open-panel-right"
              (onClick)="setSidebarPinnedState(true)"
              [pTooltip]="'Pin chat sidebar'"
              tooltipPosition="bottom"
              tooltipStyleClass="u-tooltip bottom-left"
              [versionNumber]="2"
              [sizeElement]="'small'"
            >
            </u-button>
          }
        }
        @if (assistantItem()?.state === 'enabled') {
          @if (assistantItem()?.canAccess) {
            <u-button
              type="secondary"
              fontIcon="cog2"
              (onClick)="openAssistantPage($event)"
              [pTooltip]="'Preference'"
              tooltipPosition="bottom"
              tooltipStyleClass="u-tooltip bottom-left"
              [versionNumber]="2"
              [sizeElement]="'small'"
            >
            </u-button>
          }
          @if (isHeader()) {
            <u-button
              type="secondary"
              fontIcon="pencil5"
              (onClick)="navigateToNewChat()"
              [pTooltip]="'New Chat'"
              tooltipPosition="bottom"
              tooltipStyleClass="u-tooltip bottom-left"
              [versionNumber]="2"
              [sizeElement]="'small'"
            >
            </u-button>
          }
        }
      </div>
    </div>
  </div>
}
